import { baseApi } from "./api";

export const adminUsersApi = baseApi.injectEndpoints({
	endpoints: (build) => ({
		listUsers: build.query({
			query: (type = "all") => ({
				url: "users",
				params:
					type && type !== "all" ? { type } : undefined,
			}),
			providesTags: (_result, _error, type) => [
				{ type: "AdminUsers", id: type || "all" },
			],
		}),
		listUserProjects: build.query({
			query: (userId) => ({ url: `users/${userId}/projects` }),
			providesTags: (_result, _error, userId) => [
				{ type: "AdminUserProjects", id: userId },
			],
		}),
		// Look up a user by email. Resolves with the matching user
		// ({ id, email, firstName, lastName, isProjectLocal }) or rejects
		// with a 404 when no account uses that email. Used by the add-user
		// modal to warn before submitting a duplicate.
		lookupUserByEmail: build.query({
			query: (email) => ({ url: "users/lookup", params: { email } }),
		}),
		// Activate / deactivate a user. A deactivated user is blocked at login.
		setUserStatus: build.mutation({
			query: ({ id, isActive }) => ({
				url: `users/${id}/status`,
				method: "PATCH",
				body: { isActive },
			}),
			invalidatesTags: [{ type: "AdminUsers", id: "all" }],
		}),
	}),
});

export const {
	useListUsersQuery,
	useListUserProjectsQuery,
	useLazyLookupUserByEmailQuery,
	useSetUserStatusMutation,
} = adminUsersApi;
